import Footer from "../Footer/footer";
import Header from "../Header/header";
import { useEffect, useState, useCallback } from "react";
import {
  getArticle,
  getArticleByCategory,
  getCategoriesCount,
} from "./_request";
import ListingCard from "./listingCard";
import TazakuraatHighlights from "./TazakuraatHighlights";
import { useLocation } from "react-router-dom";

const MUHASBA_CATEGORIES = [
  "محاسبہ",
  "نماز شب",
  "نماز صبح و سحر خیزی",
  "قرآن و دعا",
  "ورزش",
  "نظم ٹائم ٹیبل",
  "غور و فکر",
  "مطالعہ و حصول علم",
  "تعلیم اہل خانہ و مومنین",
  "صدقہ",
  "معرفت امام زمانہ علیہ السلام",
  "تعارف امام میں سعی",
  "احسان بہ والدین صلہ رحم",
  "امداد مؤمنین",
  "ایفائے عہد",
  "امر معروف و نهی از منکر",
  "مستحب روزه",
  "نامحرم پر نگاہ سے اجتناب",
  "غیبت و تہمت سے دوری",
  "جھوٹ ونفاق سے پر ہیز",
  "بد اخلاقی اور فحش گوئی سے اجتناب",
  "لہو ولعب سے پر ہیز غضب و غصہ سے دوری",
  "ریا کاری سے اجتناب",
  "حد سے پر ہیز",
];

export default function Tazakurat() {
  const [articles, setArticles] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [loading, setLoading] = useState(false);
  const [isCategorySelected, setIsCategorySelected] = useState(false);
  const [categoriesCount, setCategoriesCount] = useState([]);
  const location = useLocation();

  const fetchArticles = useCallback(async (category = null) => {
    setLoading(true);
    try {
      const response = category
        ? await getArticleByCategory(category)
        : await getArticle();
      if (response?.Result) {
        if (category) {
          const filteredArticles = response.Articles.filter(
            (article) => article.category?.trim() === category,
          );
          setArticles(filteredArticles);
        } else {
          setArticles(response.Articles);
        }
      } else {
        setArticles([]);
      }
    } catch (error) {
      console.error("Error fetching articles:", error);
      setArticles([]);
    } finally {
      setLoading(false);
    }
  }, []);

  const fetchCounts = useCallback(async () => {
    try {
      const response = await getCategoriesCount();
      if (response?.Result) {
        setCategoriesCount(response.CategoryCounts);
      } else {
        setCategoriesCount([]);
      }
    } catch (error) {
      console.error("Error fetching category counts:", error);
      setCategoriesCount([]);
    }
  }, []);

  // Fetch counts on mount
  useEffect(() => {
    fetchCounts();
  }, [fetchCounts]);

  // Handle category selection from route state
  useEffect(() => {
    const category = location.state?.selectedCategory;
    
    if (category) {
      setSelectedCategory(category);
      setIsCategorySelected(true);
      fetchArticles(category);
    } else {
      // Only fetch all if no category is selected
      if (!selectedCategory) {
        fetchArticles();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.state?.selectedCategory]);

  const handleCategoryClick = (category) => {
    if (selectedCategory === category) {
      setSelectedCategory(null);
      setIsCategorySelected(false);
      fetchArticles(null);
    } else {
      setSelectedCategory(category);
      setIsCategorySelected(true);
      fetchArticles(category);
    }
  };

  return (
    <>
      <Header />
      <div className="bg-white min-h-screen mt-28 px-5 sm:px-10 md:px-10 lg:px-20 text-black text-end font-nastaleeqRegular">
        <TazakuraatHighlights />
        <div className="flex flex-col lg:flex-row gap-10 md:gap-8 p-5 sm:p-10">
          {/* Sidebar */}
          <div className="w-full lg:w-1/3 flex flex-col items-end gap-3 md:gap-3">
            <div className="text-lg px-1 sm:text-xl md:text-2xl lg:text-2xl font-nastaleeqKasheeda flex justify-end">
              <p>عناوین</p>
            </div>
            {/* Yaad Imam */}
            <div className="flex flex-col gap-3 text-xl w-full">
              <div
                dir="rtl"
                className="flex justify-between items-center cursor-pointer pl-3 transition-all duration-300 hover:scale-[1.02]"
                onClick={() => handleCategoryClick("یاد امام")}
              >
                <span
                  className={`text-xl ${
                    selectedCategory === "یاد امام"
                      ? "text-primary border-r-4 border-primary pr-2"
                      : ""
                  }`}
                >
                  یاد امام
                </span>
                <span className="text-lg">
                  {categoriesCount.find((item) => item.category === "یاد امام")
                    ?.count || 0}
                </span>
              </div>
            </div>
            <div className="w-full text-black flex flex-col gap-3">
              <div className="flex flex-col text-md gap-3">
                {MUHASBA_CATEGORIES.map((cat, idx) => {
                  const count =
                    categoriesCount.find((item) => item.category === cat)
                      ?.count || 0;
                  return (
                    <div
                      dir="rtl"
                      key={idx}
                      className="flex justify-between items-center cursor-pointer pl-3 py-2 transition-all duration-300 hover:scale-[1.02]"
                      onClick={() => handleCategoryClick(cat)}
                    >
                      <span
                        className={`text-xl ${
                          selectedCategory === cat
                            ? "text-primary border-r-4 border-primary pr-2"
                            : ""
                        }`}
                      >
                        {cat}
                      </span>
                      <span className="text-lg">{count}</span>
                    </div>
                  );
                })}
              </div>
              {/* Muharram */}
              <div className="flex flex-col gap-3 text-xl">
                <div
                  dir="rtl"
                  className="flex justify-between items-center cursor-pointer px-3 py-2 transition-all duration-300 hover:scale-[1.02]"
                  onClick={() => handleCategoryClick("محرم")}
                >
                  <span
                    className={`text-xl ${
                      selectedCategory === "محرم"
                        ? "text-primary border-r-4 border-primary pr-2"
                        : ""
                    }`}
                  >
                    محرم
                  </span>
                  <span className="text-lg">
                    {categoriesCount.find((item) => item.category === "محرم")
                      ?.count || 0}
                  </span>
                </div>
              </div>
              {/* Ayyame Fatimiya */}
              <div className="flex flex-col gap-3 text-xl">
                <div
                  dir="rtl"
                  className="flex justify-between items-center cursor-pointer px-3 py-2 transition-all duration-300 hover:scale-[1.02]"
                  onClick={() => handleCategoryClick("ایام فاطمیہ")}
                >
                  <span
                    className={`text-xl ${
                      selectedCategory === "ایام فاطمیہ"
                        ? "text-primary border-r-4 border-primary pr-2"
                        : ""
                    }`}
                  >
                    ایام فاطمیہ
                  </span>
                  <span className="text-lg">
                    {categoriesCount.find(
                      (item) => item.category === "ایام فاطمیہ",
                    )?.count || 0}
                  </span>
                </div>
              </div>
            </div>
          </div>
          {/* Main Content */}
          <div className="w-full lg:w-2/3">
            {!isCategorySelected ? (
              <h1 className="text-lg sm:text-xl md:text-xl lg:text-2xl font-nastaleeqKasheeda">
                حال ہی میں پوسٹ کیا گیا۔
              </h1>
            ) : (
              <button
                onClick={() => {
                  setIsCategorySelected(false);
                  setSelectedCategory(null);
                  fetchArticles(null);
                }}
                className="bg-primaryBG px-2 py-1 rounded-xl text-lg sm:text-xl md:text-xl lg:text-2xl font-nastaleeqKasheeda transition-all duration-300 hover:scale-[1.02]"
              >
                تمام زمرے دیکھیں
              </button>
            )}
            {loading ? (
              <div className="flex justify-center items-center h-40">
                <div className="animate-spin rounded-full h-10 w-10 border-t-4 border-primary border-solid"></div>
              </div>
            ) : (
              <div className="flex flex-col">
                <ListingCard data={articles?.slice(0, 15)} />
                {articles?.length === 0 && (
                  <p className="text-center text-gray-500 mt-10">
                    کوئی مضمون موجود نہیں
                  </p>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}